export default (searchedBy, filters, agenda, user) => {
  if (agenda.patient.id === null) {
    return
  }
  filters['patient'] = agenda.patient

  searchedBy.push(agenda.patient.label)
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterByPatient.js